import {Injectable} from '@angular/core';
import {CampaignService} from '../campaign/campaign.service';
import {BaseServiceConfigurationService} from './base-service-configuration.service';
import {ServiceConfiguration} from './service-configuration';
import {BookingScopedService} from '../booking/booking-scoped.service';
import {VapsService} from "../vaps/vaps.service";

@Injectable()
export class ServicesService {

  constructor(private booking: BookingScopedService, private campaigns: CampaignService, private base: BaseServiceConfigurationService, private vaps: VapsService) {
  }

  get serviceConfiguration(): ServiceConfiguration {
    const campaign = this.campaigns.applicableCampaign;

    const {package: pkg, services} = campaign ? campaign.serviceConfiguration : this.base.serviceConfiguration;

    const booking = this.booking.booking;

    pkg?.init(booking);
    services.forEach(service => service.init(booking));

    const vapsTotal = this.vaps.vaps.filter(v => v.selected).reduce((sum, v) => sum + v.price, 0);

    const total = vapsTotal + (pkg?.effectivePrice || 0) + services.reduce((sum, service) => sum + service.effectivePrice, 0);

    return {
      package: pkg,
      services: services.filter(s => booking && s.offeredForBooking(booking)),
      total
    };
  }
}
